import { Box, CircularProgress, Link, Table, Typography } from "@mui/joy";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Util } from "../Helpers/Util";

export default function OutOfServiceElevators() {
	const [dataset, setDataset] = React.useState([] as Array<any>);
	const [loading, setLoading] = React.useState(true);

	const n = useNavigate();

	React.useEffect(() => getData(), []);

	const getData = () => {
		setLoading(true);
		fetch("Building/GetOutOfServiceElevators", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((x) => {
				setDataset(x);
				setLoading(false);
			});
	};

	return (
		<>
			<Box sx={{ overflowY: "auto", padding: 2 }}>
				<Typography level="title-lg" sx={{ marginBottom: 2 }}>
					Out of Service Elevators
				</Typography>
				<Table>
					<thead>
						<tr>
							<th>Building</th>
							<th>Serial Number</th>
							<th>Date Out of Service</th>
						</tr>
					</thead>
					<tbody>
						{loading && (
							<tr>
								<td colSpan={3}>
									<div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
										<CircularProgress />
									</div>
								</td>
							</tr>
						)}
						{!loading &&
							dataset.map((x) => (
								<tr>
									<td>
										<Link
											onClick={() => {
												n("/buildingportal/" + x.buildings_id);
											}}>
											{x.building_name}
										</Link>
									</td>
									<td>{x.serial_number}</td>
									<td>{Util.Formatter(x.date_out_of_service, "D")}</td>
								</tr>
							))}
					</tbody>
				</Table>
			</Box>
		</>
	);
}
